import { HttpClient } from '@angular/common/http';
import { normalizeApiBaseUrl } from 'src/app/shared/utils/api-base-url';
import { JSON_HTTP_OPTIONS } from 'src/app/shared/utils/json-http-options';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnquiryService {

  constructor(private router: Router, private http: HttpClient) { }
GetAllEnquiry(): Observable<any> {
    const body = {};
    return this.http.get(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Enquiry/all-enquiries`, JSON_HTTP_OPTIONS);
  }

  GetEnquiry(enquiry_id:any): Observable<any> {
    return this.http.get(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Enquiry/${enquiry_id}`, JSON_HTTP_OPTIONS);
  }

  SendOTP(enquiryData:any): Observable<any> {
    const body = enquiryData;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Enquiry/send-otp`, body, JSON_HTTP_OPTIONS);
  }

  VerifyOTP(enquiryData:any): Observable<any> {
    const body = enquiryData;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Enquiry/verify-otp`, body, JSON_HTTP_OPTIONS);
  }

  InsertEnquiry(enquiryData:any): Observable<any> {
    const body = enquiryData;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Enquiry/enquiry`, body, JSON_HTTP_OPTIONS);
  }

  UpdateEnquiry(enquiry_id: any): Observable<any> {
    const body = enquiry_id ;
    return this.http.put(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Enquiry/enquiry`, body, JSON_HTTP_OPTIONS);
  }


  DeleteEnquiry(enquiry_id:any): Observable<any> {
    return this.http.delete(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Enquiry/${enquiry_id}`, JSON_HTTP_OPTIONS);
  }
}
